/* unplugin-vue-components disabled */import script from "./KfAccountFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KfAccountFormModal.vue?vue&type=script&setup=true&lang=js"

import "./KfAccountFormModal.vue?vue&type=style&index=0&id=2f637fba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f637fba"]])

export default __exports__